import React from 'react';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Img01 from '../../img/feature3-1.png'
import Img02 from '../../img/feature3-2.png'
import Img03 from '../../img/feature3-3.png'
import { Box, Container, Typography, useMediaQuery } from '@material-ui/core';
import { AiOutlineCheck } from "react-icons/ai"
import CalculatorPng from "../../img/calculator.png"
import { withNamespaces } from 'react-i18next';

const useStyles = makeStyles((theme) => ({
    // ----------------------------------------------------
    shader: {
        backgroundColor: '#e0fcea'
    },
    fontFamily: {
        fontFamily: `'Roboto', sans-serif`,
        lineHeight: 1.25
    },
    headPreTitle: {
        textAlign: "center",
        fontSize: 35,
        fontWeight: 300,
        [theme.breakpoints.down("sm")]: {
            fontSize: 20,
        },
    },
    headTitle: {
        textAlign: "center",
        fontSize: 40,
        [theme.breakpoints.down("sm")]: {
            fontSize: 25,
        },
    },
    blockGrid: {
        minHeight: 350,
    },
    contentTitle: {
        fontWeight: "bold",
        fontSize: 25,
        [theme.breakpoints.down("sm")]: {
            fontSize: 20,
        },
    },
    contentGrid: {
        flex: 1,
    },
    content: {
        [theme.breakpoints.down("sm")]: {
            fontSize: 15,
        },
    },
    CalculatorTitle: {
        textAlign: "center",
        fontSize: 30
    },
    CalculatorSubTitle: {
        textAlign: "center",
        fontSize: 25
    },
    contentLineGrid: {
        paddingTop: 20
    },
    pt20: {
        paddingTop: 20
    }
}));

function AiBioPersonalSolution({ t }) {
    const theme = useTheme();
    const classes = useStyles();
    const themeMainColor = theme.palette.primary.main
    let IsOverMd = useMediaQuery(theme.breakpoints.up('md'))


    const ContentLine = ({ content }) => {
        return (
            <Grid item>
                <Grid item container xs={12} direction="row" alignItems="center" className={classes.contentLineGrid}>
                    <Grid style={{ paddingRight: 20 }}>
                        <AiOutlineCheck size={30} color={themeMainColor} />
                    </Grid>
                    <Grid item container className={classes.contentGrid}>
                        <Typography className={classes.content}>
                            {content}
                        </Typography>
                    </Grid>
                </Grid>
            </Grid>
        )
    }

    return (
        <Grid className={classes.fontFamily}>
            <Grid>
                <Box p={10} />
                <h1 className={classes.headPreTitle} style={{ textDecoration: "underline", textDecorationColor: themeMainColor }}>
                    {t("predictive-advise")}

                </h1>
                <h2 className={classes.headTitle}>
                    {t("why-ai")}


                </h2>
            </Grid>
            <Container>
                <Grid container item direction="row" alignItems="flex-end">
                    <Grid item md={6} xs={12}>
                        <img src={Img01} alt="img01"
                            style={{
                                width: "75%",
                                marginLeft: "auto",
                                marginRight: "auto",
                                display: "block"
                            }}
                        />
                    </Grid>
                    <Grid item container md={6} xs={12} direction="column" className={classes.blockGrid}>
                        <Grid item>
                            <Typography className={classes.contentTitle}>
                                {t("dna-insurfit-soulution")}
                            </Typography>
                        </Grid>
                        <Grid>
                            <Typography className={classes.pt20}>
                                {t("our-platform-integrates")}

                            </Typography>
                            <Typography className={classes.pt20}>
                                {t("by-using-our-DNA")}
                            </Typography>
                        </Grid>
                    </Grid>
                </Grid>
            </Container>
            <Grid className={classes.shader} style={{ paddingTop: 30, paddingBottom: 30 }}>
                <Container>
                    <Grid container item direction="row" alignItems="flex-end">
                        {
                            !IsOverMd
                            &&
                            <Grid item md={6} xs={12}>
                                <img src={Img02} alt="img02"
                                    style={{
                                        width: "70%",
                                        marginLeft: "auto",
                                        marginRight: "auto",
                                        display: "block"
                                    }}
                                />
                            </Grid>

                        }
                        <Grid item container md={6} xs={12} direction="column" className={classes.blockGrid}>
                            <Grid item>
                                <Typography className={classes.contentTitle}>
                                    {t("key-factors")}
                                </Typography>
                            </Grid>
                            <Typography className={classes.pt20}>
                                <b>{t("ai-point1-title")}</b> {t("ai-point1")}
                            </Typography>
                            <Typography className={classes.pt20}>
                                <b>{t("ai-point2-title")}</b> {t("ai-point2")}
                            </Typography>
                            <Typography className={classes.pt20}>
                                <b>{t("ai-point3-title")}</b> {t("ai-point3")}
                            </Typography>
                        </Grid>
                        {
                            IsOverMd
                            &&
                            <Grid item md={6} xs={12} justify="center">
                                <img src={Img02} alt="img02" 
                                style={{
                                    width: "70%",
                                    marginLeft: "auto",
                                    marginRight: "auto",
                                    display: "block"
                                }}/>
                            </Grid>
                        }
                    </Grid>
                </Container>
            </Grid>
            <Container>
                <Grid container item direction="row">
                    <Grid item md={6} xs={12} >
                        <img src={Img03} alt="img03"
                            style={{
                                width: "70%",
                                marginLeft: "auto",
                                marginRight: "auto",
                                display: "block"
                            }}
                        />
                    </Grid>
                    <Grid item container md={6} xs={12} direction="column" justify="center" className={classes.blockGrid}>
                        <Grid item>
                            <Typography className={classes.contentTitle}>
                                {t("precise-and-hassel-free")}
                            </Typography>
                        </Grid>
                        <ContentLine content={t("creating-bio")} />
                        <ContentLine content={t("emphasis")} />
                        <ContentLine content={t("simplifying")} />
                        <ContentLine content={t("no-pushing")} />
                        <ContentLine content={t("we-do-not")} />
                        <ContentLine content={t("all-connections")} />
                    </Grid>
                </Grid>
            </Container>
        </Grid>
    );
}
export default withNamespaces()(AiBioPersonalSolution)